import React from 'react';

const COLOR_MAP = {
  indigo: 'bg-indigo-50 text-indigo-600',
  amber: 'bg-amber-50 text-amber-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  purple: 'bg-purple-50 text-purple-600',
  pink: 'bg-pink-50 text-pink-600',
  blue: 'bg-blue-50 text-blue-600',
};

/**
 * Compact metric pill used at the top of both Reports and Dashboards list pages.
 */
const InsightCard = ({ icon: Icon, label, value, sub, color = 'indigo', onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center gap-3 bg-white rounded-2xl border border-slate-100 px-4 py-3.5 shadow-sm hover:shadow-md hover:border-indigo-200/60 transition-all duration-200 group flex-shrink-0 min-w-[160px]"
  >
    <div className={`p-2.5 rounded-xl flex-shrink-0 ${COLOR_MAP[color] || COLOR_MAP.indigo}`}>
      <Icon className="w-4 h-4" />
    </div>
    <div className="text-left min-w-0">
      <div className="text-xl font-bold text-slate-800 leading-none group-hover:text-indigo-700 transition-colors">{value}</div>
      <div className="text-xs text-slate-500 mt-0.5 truncate">{label}</div>
      {sub && <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
  </button>
);

export default InsightCard;
